var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"google-map-style-1"},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"src":"http://www.yaoxiegm.com/map.html","width":"800","height":"450","allowfullscreen":"","loading":"lazy"}})])
}]

export { render, staticRenderFns }